const css = `.KmXNyG__tableBodyCell{vertical-align:middle;background:var(--base-surfaces-default)}.KmXNyG__bordersHorizontal{border-bottom:1px solid var(--base-strokes-default)}.KmXNyG__bordersVertical{border-right:1px solid var(--base-strokes-default)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"bordersHorizontal":"KmXNyG__bordersHorizontal","tableBodyCell":"KmXNyG__tableBodyCell","bordersVertical":"KmXNyG__bordersVertical"};
